<div class="flex flex-column gap-20px">
    <h2 class="m-0">{{ isAdmin ? 'Crew' : 'Your' }} Performance</h2>
    <div class="flex flex-wrap gap-2">
        <p-dropdown
            styleClass="dropdown-rounded"
            [autoDisplayFirst]="false"
            [options]="timeFrameList"
            scrollHeight="300px"
            [formControl]="timeFrameControl">
        </p-dropdown>

        <ng-container *ngIf="riskAssessmentOptions$ | async as options">
            <p-dropdown
                *ngIf="options.length > 1"
                [options]="options"
                [formControl]="riskAssessmentControl"
                scrollHeight="300px"
                [autoDisplayFirst]="false"
                placeholder="Select assessment"
                styleClass="dropdown-rounded">
            </p-dropdown>

        </ng-container>
    </div>
    @if (!stats$ | async) {
        <app-loading-indicator
           ></app-loading-indicator>
    }
    <div class="grid">
        @if (stats$ | async; as stats) {
            @if (stats.data?.averageRiskScoreOverTime; as averageScores) {
                <div class="col-12  w-full">
                    <div class="custom-chart-wrapper">
                        <app-graphic-line
                            class=" h-15rem"  
                            [title]="'Average Score'"
                            [data]="averageScores.averageScores"
                            [meta]="averageScores.meta"
                            [chartData$]="averageScoreDataSet$"
                            [chartOptions]="ChartOptions">
                        </app-graphic-line>
                    </div>
                </div>
                
                
            }

            @if (stats.data?.completionRiskRateOverTime; as completionScore) {
                <div class="col-12  w-full">
                    <div class="custom-chart-wrapper">
                        <app-graphic-completion-rate
                            class=" h-15rem"
                            [title]="'Completion Rate'"
                            [data]="completionScore.averageScores"
                            [meta]="completionScore.meta"
                            [chartData$]="completionDataset$"
                            [chartOptions]="ChartOptions">
                        </app-graphic-completion-rate>
                    </div>
                </div>

            }

            @if (stats?.data?.allFratRiskScoreAverageOverTime; as allStats) {
                @for (card of allStats.cards.slice(1); track card) {
                    <app-graphic-average-card
                        class=" col-12  sm:col-12  h-full"
                        [title]="card.title"
                        [data]="card.data"
                        [meta]="allStats.meta">
                    </app-graphic-average-card>
                }
            }
        }
    </div>
 
</div>
